<template>
    <section id="page-combinatie" class="page-combinatie page">
        <div class="page__content">
            <div class="page__icon-wrapper"><i class="far fa-clock"></i></div>
            <h1>BEKIJK VOORBEELDEN VAN DE URENVERDELING VAN HYBRIDE DOCENTEN</h1>
            <div class="container list-select">
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col-10 list-select__title">Hoeveel uren besteden hybride docenten per week <br/>aan hun banen als ze:</div>
                </div>
                <div class="list-select__item row" v-for="option in options"
                     v-on:click="selectTypeHandler(option)"
                     v-bind:class="{'list-select__item--selected': isSelected(option)}">
                    <div class="col-2-sm list-select__item-marker-column">
                        <div class="list-select__item-marker"></div>
                    </div>
                    <div class="col-10-sm list-select__item-text">
                        {{option.text}}
                    </div>
                </div>
            </div>
            <div class="double-bar-chart container">
                <!--<div class="row">-->
                    <!--<div class="col-6-sm" style="text-align: right;"><span v-if="selected.id==='docent1'">Docent in eerste baan</span></div>-->
                    <!--<div class="col-6-sm" style="text-align: left;"><span v-if="selected.id==='docent2'">Docent in tweede baan</span></div>-->
                <!--</div>-->
                <div class="row page-combinatie__sort-controls">
                    <div class="col-6-sm page-combinatie__sort-control" v-on:click="doSort(true)">
                        <i class="fa fa-sort-numeric-desc" aria-hidden="true"></i> sorteer
                    </div>
                    <div class="col-6-sm page-combinatie__sort-control" v-on:click="doSort(false)">
                        sorteer <i class="fa fa-sort-numeric-desc" aria-hidden="true"></i>
                    </div>
                </div>
                <div v-if="selected.id==='docent1'"
                    v-for="person in filteredPersons" class="double-bar-chart__row">
                    <div class="row">
                        <div class="col-6-sm double-bar-chart__bar  double-bar-chart__bar--left double-bar-chart__bar--docent">
                            <div class="double-bar-chart__label">{{getHours(person.uren_docent)}}</div>
                            <div class="double-bar-chart__graphic" v-bind:style="barWidth(person.uren_docent)"></div>
                        </div>
                        <div class="col-6-sm double-bar-chart__bar double-bar-chart__bar--right">
                            <div class="double-bar-chart__bar-plus"></div>
                            <div class="double-bar-chart__graphic" v-bind:style="barWidth(person.uren_anders)">
                            </div>
                            <div class="double-bar-chart__label">{{getHours(person.uren_anders)}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6-sm double-bar-chart__description double-bar-chart__description--docent double-bar-chart__description--left">{{getJobDescription(person.baan_docent)}}</div>
                        <div class="col-6-sm double-bar-chart__description double-bar-chart__description--right">{{getJobDescription(person.baan_anders)}}</div>
                    </div>
                </div>

                <div v-if="selected.id==='docent2'"
                     v-for="person in filteredPersons" class="double-bar-chart__row">
                    <div class="row">
                        <div class="col-6-sm double-bar-chart__bar  double-bar-chart__bar--left">
                            <div class="double-bar-chart__label">{{getHours(person.uren_anders)}}</div>
                            <div class="double-bar-chart__graphic" v-bind:style="barWidth(person.uren_anders)"></div>
                        </div>
                        <div class="col-6-sm double-bar-chart__bar double-bar-chart__bar--right double-bar-chart__bar--docent">
                            <div class="double-bar-chart__bar-plus"></div>
                            <div class="double-bar-chart__graphic" v-bind:style="barWidth(person.uren_docent)">
                            </div>
                            <div class="double-bar-chart__label">{{getHours(person.uren_docent)}}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6-sm double-bar-chart__description double-bar-chart__description--left">{{getJobDescription(person.baan_anders)}}</div>
                        <div class="col-6-sm double-bar-chart__description double-bar-chart__description--docent double-bar-chart__description--right">{{getJobDescription(person.baan_docent)}}</div>
                    </div>
                </div>
            </div>
            <page-next-button v-on:click="nextHandler"></page-next-button>
        </div>
    </section>
</template>
<style lang="stylus">
    @require "../../styles/variables.styl";

    .page-combinatie .list-select
        margin-bottom 30px

    .page-combinatie__sort-controls
        color #bbb
        font-size .8em
        font-family $font-secondary

    .page-combinatie__sort-control
        cursor pointer
        &:hover
            color $color-main-1
        &:nth-child(1)
            text-align left
        &:nth-child(2)
            text-align right


</style>
<script>

    import flipper from '../flipper/flipper.vue';
    import page from './page';

    export default {
        mixins: [page],
        props: {
            persons: {
                type: Array,
                default: []
            }
        },
        data() {
            return {
                options: [
                    { id: 'docent1', text: 'al docent waren (docent in eerste baan)' },
                    { id: 'docent2', text: 'nog geen docent waren (docent in tweede baan)' }
                ],
                selected: { id: 'docent1' }
            }
        },
        watch: {
            'userProfile.baan1': function() {
                if (this.userProfile.baan1 && this.userProfile.baan1.label === 'Leraar') {
                    this.selected = this.options[0];
                } else {
                    this.selected = this.options[1];
                }
            }
        },
        created() {
            this.doSortOnFirst = true;
        },
        computed: {
            filteredPersons: function() {
                const docentFirst = this.selected.id === 'docent1';
                const persons = this.persons.filter( function(person) {
                    return docentFirst ? person.constructie.search('>') !== -1 : person.constructie.search('<') !== -1;
                });
                return this.sortOnFirst(persons, this.doSortOnFirst);
            }
        },
        methods: {
            isSelected(type) {
                return type.id === this.selected.id;
            },
            selectTypeHandler(type) {
                this.selected = type;
            },
            getHours(hours) {
                return Math.abs(hours);
            },
            barWidth(hours) {
                return {
                    width: `${Math.abs(hours)*3}%`
                };
            },
            getJobDescription(text) {
                return text ? text.replace(/[0-9]\./, '') : '';
            },
            sortOnFirst(persons, onFirst) {
                this.doSortOnFirst = onFirst;

                let searchProperty;
                if (this.selected.id === 'docent1') {
                    searchProperty = onFirst ? 'uren_docent' : 'uren_anders';
                } else {
                    searchProperty = !onFirst ? 'uren_docent' : 'uren_anders';
                }
                return persons.sort( (a, b) => {
                    return Math.abs(b[searchProperty]) - Math.abs(a[searchProperty]);
                });
            },
            doSort(onFirst) {
                this.persons = this.sortOnFirst(this.persons, onFirst);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// page-combinatie.vue?d5fe4c86